import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

const SuggestionModal = ({ user, location, onClose }) => {
  const [suggestion, setSuggestion] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!suggestion.trim()) {
      toast.error('Proszę wpisać pomysł');
      return;
    }

    setIsSubmitting(true);

    try {
      await axios.post(`${API}/api/development/suggestions`, {
        suggestion: suggestion.trim(),
        submitted_by: user.username,
        location: location
      });

      // Success notification
      toast.success('✅ Pomysł został wysłany!');
      
      // Thank you message from development team
      setTimeout(() => {
        toast.success('🙏 Zespół rozwoju aplikacji dziękuje za Twój wkład w ulepszanie systemu!', {
          duration: 5000
        });
      }, 800);

      setSuggestion('');
      setTimeout(() => onClose(), 2500);
    } catch (error) {
      console.error('Error submitting suggestion:', error);
      toast.error('Nie udało się zgłosić pomysłu');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div 
      className="modal-overlay" 
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000,
        padding: '20px'
      }}
    >
      <div 
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'var(--bg-card)',
          borderRadius: '16px',
          padding: '32px',
          maxWidth: '600px',
          width: '100%',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)',
          border: '1px solid var(--border-color)'
        }}
      >
        <div style={{ marginBottom: '24px' }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: 'var(--text-primary)',
            marginBottom: '8px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}>
            💡 Zgłoś pomysł
          </h2>
          <p style={{
            fontSize: '14px',
            color: 'var(--text-muted)',
            lineHeight: '1.6'
          }}>
            Masz pomysł na nową funkcję lub ulepszenie aplikacji? Podziel się nim z nami!
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '24px' }}>
            <label style={{
              display: 'block',
              fontSize: '14px',
              fontWeight: '600',
              color: 'var(--text-primary)',
              marginBottom: '8px'
            }}>
              Twój pomysł *
            </label>
            <textarea
              value={suggestion}
              onChange={(e) => setSuggestion(e.target.value)}
              placeholder="Opisz swój pomysł... (np. 'Dodaj możliwość filtrowania raportów po dacie')"
              rows={6}
              className="input-field"
              style={{
                width: '100%',
                resize: 'vertical',
                minHeight: '120px',
                fontFamily: 'inherit',
                fontSize: '14px',
                lineHeight: '1.5'
              }}
              required
              disabled={isSubmitting}
            />
            <div style={{
              fontSize: '12px',
              color: 'var(--text-muted)',
              marginTop: '6px',
              display: 'flex',
              justifyContent: 'space-between'
            }}>
              <span>Bądź jak najbardziej szczegółowy</span>
              <span>{suggestion.length} znaków</span>
            </div>
          </div>

          <div style={{
            display: 'flex',
            gap: '12px',
            justifyContent: 'flex-end'
          }}>
            <button
              type="button"
              onClick={onClose}
              className="btn-secondary"
              style={{
                padding: '10px 20px',
                fontSize: '14px',
                fontWeight: '600',
                borderRadius: '8px',
                border: '1px solid var(--border-color)',
                background: 'transparent',
                color: 'var(--text-primary)',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              disabled={isSubmitting}
            >
              Anuluj
            </button>
            <button
              type="submit"
              className="btn-primary"
              style={{
                padding: '10px 24px',
                fontSize: '14px',
                fontWeight: '600',
                borderRadius: '8px',
                border: 'none',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: '#fff',
                cursor: isSubmitting ? 'not-allowed' : 'pointer',
                opacity: isSubmitting ? 0.6 : 1,
                transition: 'all 0.2s'
              }}
              disabled={isSubmitting}
            >
              {isSubmitting ? '⏳ Wysyłanie...' : '✉️ Wyślij pomysł'}
            </button>
          </div>
        </form>

        <div style={{
          marginTop: '20px',
          padding: '12px',
          background: 'var(--bg-secondary)',
          borderRadius: '8px',
          fontSize: '12px',
          color: 'var(--text-muted)',
          lineHeight: '1.5'
        }}>
          <strong>ℹ️ Informacja:</strong> Twój pomysł zostanie przesłany do zespołu rozwoju aplikacji. Rozważymy wszystkie sugestie i postaramy się wdrożyć najbardziej wartościowe ulepszenia.
        </div>
      </div>
    </div>
  );
};

export default SuggestionModal;
